import { z } from "zod";

export type TranslatedText = z.infer<typeof TranslatedTextSchema>;
export const TranslatedTextSchema = z.object({
  lang_cd: z.string(),
  trans_text: z.string(),
});
